import { OfferActionsEnum } from '~utils/OffersEnum';
import IOffer from '~domain/entities/Offer/IOffer';
import { IUpdateOfferPayload } from '~exported/cart-sidebar-cart-offers/OffersViewController/IOffersViewController';
import { updateOfferByOfferCode } from '~api/OffersAPI/OffersAPI';

export default class UpdateOfferUseCase {
    private offerCode: IOffer['offerCode'];
    private action: OfferActionsEnum;
    private requestPayload: IUpdateOfferPayload;

    constructor({ offerCode, action }: IUpdateOfferPayload) {
        this.offerCode = offerCode;
        this.action = action;
        this.requestPayload = { offerCode: this.offerCode, action: this.action };
    }

    public execute = () => updateOfferByOfferCode(this.requestPayload);
}
